export default __webpack_public_path__ + "static/media/banner-img2.56c550fb.png";